<template>
  <div class="customize-tag-wrap sidemenu" :class="dark_mode ? 'dark' : ''" :id="'tag-wrap-' + sns_type" @click.self="click()" v-if="mounted">
    <div v-for="(tag, tag_index) in select_tag" :key="tag.tag_id" class="customize-tag small" :class="tag.tag_color">
      <TruncateText :text="tag.tag_name" :maxBytes="30" />
      <div class="customize-tag-times pointer" @click="deleteTag(tag_index)"><font-awesome-icon :icon="['fal', 'times']" /></div>
    </div>
    <input
      placeholder="カスタマイズタグを選択"
      class="customize-tag-input sidemenu"
      :class="dark_mode ? 'dark' : ''"
      size="mini"
      v-model="new_tag"
      @input="suggestTag()"
      @focus="side_suggest_tag = true"
      @blur="suggest_on ? '' : (side_suggest_tag = false) & (suggest_hover = -1)"
      @keydown.enter.prevent
      :disabled="permission && !permission.access"
      :id="'sidemenu-tag-input-' + sns_type"
    />
    <div class="customize-tag-suggest-box-wrap sidemenu" id="side-tag-box" :class="tag_list.length > 9 ? 'scroll' : ''" v-show="side_suggest_tag" :style="'top:' + wrap_height + 'px'">
      <div
        v-for="(tag, index) in tag_list"
        :key="tag.tag_id"
        class="customize-tag-suggest-box"
        :class="suggest_hover == index ? 'hover' : ''"
        @click="selectTag(tag)"
        @mouseover="(suggest_on = true) && (suggest_hover = index)"
        @mouseleave="(suggest_on = false) && (suggest_hover = -1)"
        v-show="!tag.added"
      >
        <div class="customize-tag small" :class="tag.tag_color">{{ tag.tag_name }}</div>
        <div class="flex-space"></div>
      </div>
    </div>
    <font-awesome-icon :icon="['fal', 'times-circle']" class="pointer customize-tag-clear" v-show="select_tag.length" @click="clearTag()" />
  </div>
</template>

<script>
import TruncateText from '../common/TruncateText.vue';

const root = process.env.VUE_APP_API;
const loadTagAPI = root + "/api/note/load_tag";
export default {
  name: "sidemenuCustomizeTag",
  components: {
    TruncateText
  },
  props: {
    sns_type: { type: String },
    filter: { type: Object },
    edit_tag: { type: Object },
  },
  data() {
    return {
      mounted: false,
      drawer: false,
      new_tag: "",
      side_suggest_tag: false,
      suggest_on: false,
      suggest_hover: -1,
      suggest_loading: false,
      tag_list: [],
      select_tag: [],
      requestId: +new Date(),
      test: "",
      wrap_height: 0,
      target_form: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    dark_mode() {
      if (this.sns_type=='edit_bulk'){
        return false
      } else {
        return this.$store.state.dark_mode;
      }
    },
    form() {
      if (this.sns_type == "instagram") return this.$store.state.form;
      if (this.sns_type == "youtube") return this.$store.state.form_youtube;
      if (this.sns_type == "tiktok") return this.$store.state.form_tt;
      if (this.sns_type == "twitter") return this.$store.state.form_tw;
      if (this.sns_type == "filter") return this.filter;
      if (this.sns_type == "edit_bulk") return this.edit_tag;
      else return false;
    },
    permission() {
      return this.$store.state.permission.note;
    },
  },
  created() {
    if (this.sns_type == "instagram") {
      this.target_form = 'form';
    } else if (this.sns_type == "youtube") {
      this.target_form = 'form_youtube';
    } else if (this.sns_type == "tiktok") {
      this.target_form = 'form_tt';
    } else if (this.sns_type == "twitter") {
      this.target_form = 'form_tw';
    }
  },
  mounted() {
    this.mounted = true;
    this.$nextTick(() => {
      // edit_tag.tags存在することによりタグが重複して重複して描画される可能性があるためコメントアウトしている
      // 詳細：https://dohouse.backlog.jp/view/REECH-1302#comment-217172969
      if(this.edit_tag) this.edit_tag.tags = {}
      this.loadTag(true);
      this.calcHeight();
    });
  },
  methods: {
    click() {
      if (this.permission.access) {
        this.side_suggest_tag = true;
        this.calcHeight();
        this.loadTag();
        setTimeout(() => {
          document.getElementById("sidemenu-tag-input-" + this.sns_type).focus();
        }, 100);
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    loadTag(isInit = false) {
      this.suggest_loading = true;
      this.axios
        .get(loadTagAPI, {
          params: {
            token: this.token,
          },
        })
        .then((response) => {
          this.tag_list = response.data.tag_list;

          // 初期表示時のみ検索条件読み込み待ち
          // TODO 力技対応なのでリファクタリングしたい
          const ms = isInit ? 3000 : 0;
          setTimeout(() => {
            for (let i = 0; i < this.tag_list.length; i++) {
              for (let j = 0; j < this.form.tags.length; j++) {
                if (this.tag_list[i].tag_id == this.form.tags[j]) {
                  this.tag_list[i].added = true;
                }
              }
            }
            this.suggest_loading = false;

            if (isInit) {
              // 下記処理が実行されることによりタグが重複して描画される可能性があるためコメントアウトしている
              // 詳細：https://dohouse.backlog.jp/view/REECH-1302#comment-217172969
              // this.initTags();
            }
          }, ms);
        })
        .catch(() => {});
    },
    suggestTag() {
      this.suggest_loading = true;
      this.side_suggest_tag = true;
      this.suggest_hover = -1;
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      this.axios
        .get(loadTagAPI, {
          requestId: this.requestId,
          params: {
            token: this.token,
            query: this.new_tag,
          },
        })
        .then((response) => {
          this.tag_list = response.data.tag_list;
          for (let i = 0; i < this.tag_list.length; i++) {
            for (let j = 0; j < this.form.tags.length; j++) {
              if (this.tag_list[i].tag_id == this.form.tags[j]) {
                this.tag_list[i].added = true;
              }
            }
          }
          this.suggest_loading = false;
        })
        .catch(() => {});
    },
    selectTag(tag) {
      this.select_tag.push(tag);
      this.side_suggest_tag = false;
      this.loadTag();
      this.new_tag = "";
      this.tagsUpdate();
    },
    deleteTag(tag_index) {
      this.select_tag.splice(tag_index, 1);
      this.loadTag();
      this.tagsUpdate();
    },
    clearTag() {
      this.select_tag = [];
      this.loadTag();
      this.tagsUpdate();
    },
    tagsUpdate() {
      var tags = [];
      for (let i = 0; i < this.select_tag.length; i++) {
        tags.push(Number(this.select_tag[i].tag_id));
      }
      this.form.tags = tags;
      if (this.sns_type == "filter") {
        this.$emit("update:filter", this.form);
        this.$emit("filterList");
      } else if (this.sns_type=='edit_bulk') {
        this.$emit("update:edit_tag", this.form);
      } else {
        this.$store.dispatch(this.target_form, this.form);
        this.$emit("resultCount");
      }
    },
    suggestHover(type, position) {
      if (type == "up") {
        if (this.suggest_hover == -1) this.suggest_hover += 0;
        else this.suggest_hover -= 1;
      } else if (type == "down") {
        if (this.suggest_hover == this.tag_list.length - 1) this.suggest_hover += 0;
        else this.suggest_hover += 1;
      }
      var suggest_position = 30;
      var target = document.getElementById(position);
      target.scrollTop = (this.suggest_hover - 5) * suggest_position;
    },
    calcHeight() {
      var ClientRect = document.getElementById("tag-wrap-" + this.sns_type).getBoundingClientRect();
      this.wrap_height = ClientRect.height + 10;
    },
    initTags() {
      // 画面再描画時のカスタマイズタグ設定
      const formTags = this.form.tags;
      for (let i = 0; i < formTags.length; i++) {
        // this.form.tags[i]:タグID
        const selected_tag = this.tag_list.find((tag) => tag.tag_id === formTags[i]);
        if (selected_tag != undefined) {
          this.selectTag(selected_tag);
        }
      }
    }
  },
  watch: {
    form: {
      handler() {
        if (this.form.tags && this.form.tags.length == 0) this.select_tag = [];
        this.$nextTick(() => {
          this.calcHeight();
        });
      },
      deep: true,
    },
  },
};
</script>
